import { ED_MODAL_EVENTS } from '@/plugins/ed-modal/ed-modal.plugin';
import * as bootstrap from 'bootstrap';

export default {
  name: 'ed-bootstrap-modal',
  data: () => {
    return {
      component: null,
      params: {},
      moreParams: {},
      modal: null
    }
  },
  computed: {
    classes() {
      return { 'ed-modal-container--shown': this.shown, 'ed-modal-container--on-front': this.onFront  }
    }
  },
  methods: {
    show() {
      this.modal.show();
    },
    hide() {
      this.modal.hide();
      setTimeout(() => {
        this.component = null;
      }, 300);
    },
  },
  mounted() {
    var modalElement = document.getElementById('ed-bootstrap-modal');

    this.modal = new bootstrap.Modal(modalElement);

    this.$EdModal.$on(ED_MODAL_EVENTS.ED_CREATE_BOOTSTRAP_MODAL, ({ modal, params, moreParams }) => {
      if(modal) {
        this.component = modal;
        this.params = params;
        this.moreParams = moreParams;
      }
      this.show();
    });
    this.$EdModal.$on(ED_MODAL_EVENTS.ED_BOOTSTRAP_MODAL_HIDE, this.hide);
  },
  destroyed() {
    this.moreParams = {};
  }
};
